/* global angular */

(function () {
'use strict';

angular.module('gc.filters', [])

.factory("getUserImage", function () {
  return function (user) {
    if (!user) {
      return 'img/avatar_3.png';
    }

    if (user.cached_author) {
      return user.cached_author.picture;
    }

    return user.picture;
  };
})

.filter('getUserAvatar', ['$filter', function($filter) {
  return function(cmt) {
    return `
      <div class="gc-avatar">
        <img
           class="gc-profile-picture"
           src="${$filter('extractImgCmt')(cmt)}"
           alt=""
           />
           </div>
      <b>${cmt.cached_author.username}</b>
    `;
  };
}])

.filter('slice', function () {
  return function (arr, index) {
    if (!Array.isArray(arr)) {
      return [];
    }
    var startIndex = Number(index) || 0;
    return arr.slice(startIndex);
  };
})

.filter('fromNow', function () {
  return function (dateString) {
    return moment(new Date(dateString)).fromNow();
  };
})

.filter('simpleDate', function () {
  return function (dateString) {
    return moment(new Date(dateString)).format('LLLL');
  };
})

.filter('shortDate', function () {
  return function (dateString) {
    return moment(new Date(dateString)).format('LL');
  };
})

.filter('dateTime', function () {
  return function (dateString) {
    return moment(new Date(dateString)).format('YYYY-MM-DD HH:mm:ss');
  };
})

.filter('moment', function () {
  return function (dateString, template) {
    return moment(new Date(dateString)).format(template);
  };
})

.filter('plusminus', function () {
  return function (val) {
    return val > 0 ? '+' + val : val;
  };
})

.filter('plusminusLabel', function () {
  return function (val) {
    return 'ratings' + (val + 3);
  };
})

.filter('truncate', function () {
  return function (text, length, expanded) {
    if (!text) {
      return '';
    }
    if (isNaN(length)) {
      length = 10;
    }

    var end = "...";

    if (expanded) {
      return text;
    }

    if (text.length <= length || text.length - end.length <= length) {
      return text;
    }
    else {
      return text.substring(0, length - end.length) + end;
    }
  };
})


.filter('extractImgCmt', [
  'BASE_URL',
  function (BASE_URL) {
    return function (cmt) {
      if (!cmt.cached_author) return '';

      var picture = cmt.cached_author.avatar || cmt.cached_author.picture;
      if(/^(https?|data):/.test(picture)){
        return picture;
      }
      return picture.slice(0, 'http'.length) === 'http'
        ? picture
        : BASE_URL + picture
      ;
    };
  }])

.filter('userImage', [
  'BASE_URL',
  function (BASE_URL) {
    return function (user) {
      if (user && typeof user.picture === "string" && user.picture.indexOf('images/avatar_3.png') === -1 && !/^(https?|data):/.test(user.picture)) {
        return user.picture.slice(0, 'http'.length) === 'http' ? user.picture : BASE_URL + user.picture;
      }else if(user && typeof user.picture === "string" && /^(https?|data):/.test(user.picture)){
        return user.picture;
      }
      return '/images/avatar_3.png';      
    };
  }])

.filter('ecdUserImage', [
  'BASE_URL',
  function (BASE_URL) {
    return function (comment) {
      if (comment && typeof comment.user_picture === "string" && comment.user_picture.indexOf('images/avatar_3.png') === -1 && !/^(https?|data):/.test(comment.user_picture)) {
        return comment.user_picture.slice(0, 'http'.length) === 'http' ? comment.user_picture : BASE_URL + comment.user_picture;
      }else if(comment && typeof comment.user_picture === "string" && /^(https?|data):/.test(comment.user_picture)){
        return comment.user_picture;
      }
      return '/images/avatar_3.png';
      
    };
  }])

.filter('removeDuplicatedAvatar', function () {
  return function (items) {
    var newList = [];
    items.forEach(function (item) {
      var found = false;
      newList.forEach(function (newItem) {
        if (item.user_picture === newItem.user_picture) {
          found = true;
        }
      });
      if (!found) {
        newList.push(item);
      }
    });
    return newList;
  };
})

/**
 * Extract username if not found (cached)
 */
.filter('extractUsername', function () {
  return function (cmt) {
    if (cmt.username) {
      return cmt.username;
    }
    else if (cmt.cached_author) {
      return cmt.cached_author.username;
    }
    console.error('[GcFilter] failed to extract username', cmt);
    return '<username>';
  };
})

/**
 * Extract url to access to the user profile
 */
.filter('extractProfileUrl', [
  'extractUsernameFilter',
  'BASE_URL',
  function (extractUsernameFilter, BASE_URL) {
    return function (cmt) {
      var username = extractUsernameFilter(cmt);

      if (username === 'Deleted User') {
        return '';
      }

      return BASE_URL + "/users/" + username;
    };
  }])

.filter('beautifyJson', function () {
  return function (json) {
    var str = angular.copy(json);
    return JSON.stringify(str, null, 4);
  };
})

.filter('capitalize', function () {
  return function (str) {
    if (str !== undefined) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return '';
  };
})

.filter('highlight', function () {
  return function (string, param) {
    if (!param.term || param.term.length < 3) {
      return string;
    }
    return string.replaceAll(param.term, '<span class="match">$&</span>');
  };
})

.filter('bytesToMb', function () {
  var bytesToSize = function (bytes, precision) {
    var kilobyte = 1024;
    var megabyte = kilobyte * 1024;
    var gigabyte = megabyte * 1024;
    var terabyte = gigabyte * 1024;

    if ((bytes >= 0) && (bytes < kilobyte)) {
      return bytes + ' B';
    } else if ((bytes >= kilobyte) && (bytes < megabyte)) {
      return (bytes / kilobyte).toFixed(precision) + ' KB';
    } else if ((bytes >= megabyte) && (bytes < gigabyte)) {
      return (bytes / megabyte).toFixed(precision) + ' MB';
    } else if ((bytes >= gigabyte) && (bytes < terabyte)) {
      return (bytes / gigabyte).toFixed(precision) + ' GB';
    } else if (bytes >= terabyte) {
      return (bytes / terabyte).toFixed(precision) + ' TB';
    } else {
      return bytes + ' B';
    }
  };

  return function (bytes) {
    return bytesToSize(bytes, 1);
  };
})
  .filter('limitHtml', function() {
    return function(text, limit, ellipsis) {
      var _getClosedTagsString = function(_tagArray) {
          var _returnArray = [],
            _getTagType = function(_string) {
              return _string.replace(/<[\/]?([^>]*)>/,"$1");
            };

          angular.forEach(_tagArray,function(_tag,_i) {
            if(/<\//.test(_tag)) {
              if(_i === 0) {
                _returnArray.push(_tag);
              } else if(_getTagType(_tag) !== _getTagType(_tagArray[_i - 1])) {
                _returnArray.push(_tag);
              }
            }
          });
          return _returnArray.join('');
        },
        _countNonHtmlCharToLimit = function(_text,_limit) {
          var _isMarkup = false,
            _isSpecialChar = false,
            _break = false,
            _underLimit = false,
            _totalText = 0,
            _totalChar = 0,
            _element,
            _return = {
              textCounter   : 0,
              offsetCounter : 0,
              setEllipsis   : false,
              overElementArray : []
            };
          angular.forEach(_text,function(_c) {
            _underLimit = _return.textCounter < _limit;
            if(_c === '<' && !_isMarkup && !_isSpecialChar) {
              (!_underLimit) && (_element = '<');
              _isMarkup = true;
            } else if(_c === '&' && !_isMarkup && !_isSpecialChar) {
              _isSpecialChar = true;
            } else if(_isMarkup) {
              //tracking html elements that are beyond the text limit
              (!_underLimit) && (_element = _element + _c);
              if(_c === '>') {
                //push element in array if it is complete, and we are
                //beyond text limit, to close any html that is unclosed
                (!_underLimit) && (_return.overElementArray.push(_element));
                _break = true;
                _isMarkup = false;
              }
            } else if(_c === ';' && _isSpecialChar) {
              _isSpecialChar = false;
              //count as one character
              _return.textCounter++;
              _break = true;
            }

            if(_underLimit) {
              if(!_isMarkup && !_isSpecialChar && !_break) {
                //counting number of characters in non html string
                _return.textCounter++;
              }
              _return.offsetCounter++;
            } else {
              _return.setEllipsis = true
            }
            _break = false;

          });

          //returns offset within html of number of non html characters found
          return _return;
        },
        _charToLimitOutput = _countNonHtmlCharToLimit(text.toString(),limit);

      return text.toString().substr(0, _charToLimitOutput.offsetCounter) +
        ellipsis + _getClosedTagsString(_charToLimitOutput.overElementArray);
    }
  })

  .filter('commentImages', ['API_URL', 'CommentService', function (API_URL, CommentService) {
    return function (content) {
      var maxExternalImages = CommentService.website.embeded_files;
      var disableImages = !CommentService.website.edition.upload;
      return htmlImages(
        content,
        API_URL,
        maxExternalImages,
        disableImages
      );
    }
  }])

  .filter('htmlContent', ['API_URL', 'CommentService', function (API_URL, CommentService) {
    return function(content) {
      var maxExternalImages = CommentService.website.embeded_files;
      var disableImages = !CommentService.website.edition.upload;
      return htmlImages(
        htmlContent(content, CommentService.website.edition.link),
        API_URL,
        maxExternalImages,
        disableImages
      );
    }
  }])

.filter('orderByCustomFunction', function () {
  return function (items, customFunction) {
    return items.sort(customFunction);
  };
})

.filter("htmlSafe", ['$sce', function ($sce) {
  return function (htmlCode) {
    return $sce.trustAsHtml(htmlCode);
  };
}])

// Extrats the domain name very simply (not robust)
// and removes the "www" if any.
.filter("getDomain", function () {
  return function (url) {
      var match = /https?:\/\/(?:www.)?([^\/]+)/i.exec(url);
      return match ? match[1] : null;
  };
})

.filter('isOwner', ['CommentService', function (CommentService) {
  return function (comment) {
    var website = CommentService.website;
    var authorId = comment.author && comment.author._id;
    return website.owner === authorId;
  };
}])

.filter('isAdministrator', ['CommentService', function (CommentService) {
  return function (comment) {
    var website = CommentService.website;
    var authorId = comment.author && comment.author._id;
    return website.administrators && website.administrators.indexOf(authorId) !== -1;
  };
}])

.filter('isModerator', ['CommentService', function (CommentService) {
  return function (comment) {
    var website = CommentService.website;
    var authorId = comment.author && comment.author._id;
    return website.moderators && website.moderators.indexOf(authorId) !== -1;
  };
}])


.filter('round', [function () {
  return function (value, decimals) {
    decimals = decimals || 0;
    var multiplier = decimals === 0 ? 1 : 10 * decimals;
    return Math.round(value * multiplier) / multiplier;
  };
}])
;

})();


function htmlImages(content, baseImgUrl, maxExternalImages, disableImages) {
  // Si l’affichage des images est désactivé,
  // on retourne simplement le contenu sans transformation
  if (disableImages) {
    return content;
  }

  var imagesCount = 0;

  // 1) Remplacement des liens d'images externes
  content = content.replace(
      /"[^"]*"|(https?:\/\/[^\/\s]+\/\S+\.(?:gif|jpe?g|tiff|png|svg|webp))\b/gi,
      function (pattern, match) {
        // Si `match` est l'URL capturée
        if (!match) return pattern;

        imagesCount++;
        if (imagesCount <= maxExternalImages) {
          // Insère l'image cliquable (lien + <img>)
          return '<a href="' + match + '" target="_blank">' +
              '<img src="' + match + '" alt="" />' +
              '</a>';
        } else {
          // Dépassement de la limite : on laisse l’URL en texte
          return match;
        }
      }
  );

  // 2) Remplacement des images de type MongoID (ex : 5a328e37f2fc5923f6f33787.jpg)
  content = content.replace(
      /(?!")([a-z0-9]{24}\.(?:gif|jpg|jpeg|tiff|png|svg|webp))(?!")/gi,
      function (pattern) {
        imagesCount++;
        if (imagesCount <= maxExternalImages) {
          return '<a href="' + baseImgUrl + '/file/' + pattern + '" target="_blank">' +
              '<img src="' + baseImgUrl + '/file/' + pattern + '" alt="" />' +
              '</a>';
        } else {
          // Dépassement de la limite : on laisse l’URL en texte
          return pattern;
        }
      }
  );

  return content;
}


function htmlContent(content, parseLinks) {
  function formatLinks(match, p1) {
    // if website.edition.link is disabled
    if (!parseLinks) return p1;
    // ignore images
    if (/(\.gif|jpg|jpeg|tiff|png|svg|webp)$/.test(p1)) return p1;
    return '<a href="' + p1 + '" class="gc-link" rel="nofollow" target="_blank">' + p1 + '</a>';
  }

  return content
    // code blocks
    .replace(/`{3}(<br \/>)?([\s\S]*?)`{3}(<br \/>)?/gm, '<pre>$2</pre>')
    .replace(/`([\s\S]*?)`/gm, '<code>$1</code>')

    // Replace the div by br
    .replace(/<div>/g, '')
    .replace(/<\/div>/g, '<br />')

    // Replace all the &lt;br/&gt; and \n by <br/> (\h : horizontal whitespace)
      //(\h*((&lt;br\h{0,1}\/{0,1}\h{0,1}&gt;)|(\r\n|\n|\r))\h*)
    .replace(/((&lt;br\h{0,1}\/{0,1}\h{0,1}&gt;)|(\r\n|\n|\r))/g, '<br />')

    // Allow at max two br
    .replace(/(\s*<br\s*\/>){3,}/g, '<br /><br />')
    .replace(/&nbsp;/g, '')

    // remove links with 'href' attribute
    .replace(/<a(?![^>]+href).*?>(.*?)<\/a>/g, '$1')

    // parse links
    .replace(/$/, ' ') // fix regex below not matching if no empty space at the end
    .replace(
      /(https?:\/\/[^"<\s]+[^.<\s"()][-A-Za-z0-9+&@#\/%=~_|])(?![^<>]*>|[^"]*?<\/a)(?=\s|$)/gi,
      formatLinks
    )
  ;
}
